import { ExportAllListActions } from '../ExportAllButton';
import React from 'react';
import {
  CreateGuesser,
  InputGuesser,
  ShowGuesser,
  FieldGuesser,
} from '@api-platform/admin';
import {
  List,
  TextInput,
  DateField,
  Datagrid,
  ShowButton,
  ReferenceInput,
  SelectInput,
} from 'react-admin';
import { Grid } from '@mui/material';
import { getSelectedCompanyFilter } from '../../helper/filter';

export const SpammerList = (props) => {
  const filters = [
    <TextInput label="Firstname" source="firstname" />,
    <TextInput label="Lastname" source="lastname" />,
    <TextInput label="Email" source="email" />,
  ];

  return (
    <List actions={<ExportAllListActions />} {...props} filters={filters}>
      <SpammerListFields />
    </List>
  );
};

export const SpammerListFields = () => {
  return (
    <Datagrid>
      <FieldGuesser source={'email'} />
      <FieldGuesser source={'firstname'} />
      <FieldGuesser source={'lastname'} />
      <FieldGuesser source={'ip'} />
      <DateField source={'createdAt'} locales={'de'} showTime />
      <ShowButton />
    </Datagrid>
  );
};

export const SpammerCreate = (props) => {
  const companyFilter = getSelectedCompanyFilter();

  return (
    <CreateGuesser {...props}>
      <Grid container spacing={4} sx={{ p: 2 }}>
        <Grid item xs={4}>
          <ReferenceInput
            source="company"
            reference="companies"
            label="Company"
            filterToQuery={(searchText) => ({ name: searchText })}
          >
            <SelectInput
              required
              fullWidth
              source="company"
              optionText="name"
              disabled={true}
              defaultValue={companyFilter.company}
            />
          </ReferenceInput>
          <InputGuesser fullWidth source={'email'} />
          <InputGuesser fullWidth source={'firstname'} />
          <InputGuesser fullWidth source={'lastname'} />
        </Grid>
      </Grid>
    </CreateGuesser>
  );
};

export const SpammerShow = (props) => (
  <>
    <ShowGuesser {...props}>
      <FieldGuesser source={'email'} />
      <FieldGuesser source={'firstname'} />
      <FieldGuesser source={'lastname'} />
      <FieldGuesser source={'ip'} />
    </ShowGuesser>
  </>
);
